import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setEmptyCurrentBien, resetCurrentBien } from './biensSlice'
import BienForm from './BienForm'
import Modal from '@/components/ui/Modal'
import { useContactContext } from '../contacts/ContactShow'

import { PlusIcon } from '@heroicons/react/24/outline'

const AddBienButton = ({disabled = false}) => {
  const dispatch = useDispatch()
  const isCreating = useSelector((state) => state.biens.loadingStatus.createBien)
  const success = useSelector((state) => state.biens.requestStatus.success)

  const { isOpen, handleShow, handleHide, dialogRef } = Modal.useModal()

  const contextValue = useContactContext?.()
  const contact = contextValue?.contact

  // Effet pour fermer le modal uniquement si l'opération est réussie
  useEffect(() => {
    // Si le formulaire a été soumis avec succès (isCreating est passé à false ET success est true)
    if (!isCreating && success && isOpen) {
      closeModal()
    }
  }, [isCreating, success, isOpen])

  const openModal = () => {
    dispatch(setEmptyCurrentBien(contact ? 
      {proprietaires: [
        { id: contact.id, 
          nom_complet: contact.nom_complet
        }
      ]} : 
      {} ))
    handleShow()
  }
  const closeModal = () => {
    dispatch(resetCurrentBien())
    handleHide()
  }

  return (
    <>
      <button 
        className="btn btn-primary" 
        onClick={openModal}
        disabled={disabled}
      >
        <PlusIcon className="h-5 w-5 mr-1"/>
        Ajouter un bien{ contact && ` en propriété`}
      </button>

      <Modal
        open={isOpen}
        onClose={closeModal}
        ref={dialogRef}
        backdrop={false}
        className="max-w-full rounded-none"
      >
        <Modal.Header showCloseButton={false}/>
        <Modal.Body>
          <BienForm onSuccess={closeModal} onClose={closeModal} />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddBienButton